import {BaseConfig} from "../../../../infrastructure/config/base-config";
import {LiveStreamingModuleTerms} from "./live-streaming-module.terms";
import {APP} from "../../../../core/app/consts";

export class LiveStreamingModuleConfig extends BaseConfig {

  static injectables = [LiveStreamingModuleTerms];

  constructor(terms: LiveStreamingModuleTerms) {
    super('liveStreamingModule', null, terms);

    this.source = APP.ANALYTICS.SOURCES.liveStreaming;
  }
}
